import { useEffect, useState } from "react";
import useDataBean from "../../../../../../../core/services/dataBean/useDataBean";
import { _BudgetMovementFactory, _RemoteAbstractAction, _single } from "../../../../../../../core/services/dataBean/EntityCatalog";
import { PrintJson } from "../../../../../../theme/Component/PrintJson";
import { BasicTable, MASK_MONEY, MASK_NUMBER } from "../../../../../../theme/Component/BasicTable";
import { ListMenu } from "../../../../../../theme/Component/ListMenu";
import { Modal } from "../../../../../../theme/Component/Modal";
import { InputMoney } from "../../../../../../theme/Input/InputMoney";
import { SelectBudgetResourceForYear } from "../../../../../../admin/configuracion/BudgetResource/BudgetResourceForYear";
import { SelectBudgetSourceForYear } from "../../../../../../admin/configuracion/BudgetSource/SelectBudgetSourceForYear";
import { BasicButton } from "../../../../../../theme/Component/BasicButton";
import { toast } from "react-toastify";
import { SelectBudgetID } from "../../../../../../admin/configuracion/BudgetID/SelectBudgetID";
import { SelectBudgetType } from "../../../../../../admin/configuracion/select/SelectBudgetType";
import { _BudgetSource } from "../../../../../../../core/services/dataBean/EntityCatalogVdos";
import { AdquisitionItemSelector } from "../../../../../../contract/etapa-contrato/contrac/ublinvoice/AdquisitionItemEditor/AdqusitionItemSelector";
import { BudgetResourceEditor } from "../../../../../../admin/configuracion/BudgetResource/BudgetResource.Editor";
import { SelectBudgetSource } from "../../../../../../admin/configuracion/BudgetSource/SelectBudgetSource";

interface Props {
    idApplicationInvoker: number,
    properties: any;
    data: any;
    setData: any;
    lastStep: boolean;
}
export const BudgetMovementAdjustmentAction = ({ idApplicationInvoker, properties, lastStep, data, setData }: Props) => {

    const { instance, lista, setLista, bean, setBean } = useDataBean(_RemoteAbstractAction);
    const _budgetSource = useDataBean(_BudgetMovementFactory);
    const [adquisitionItemFrom, setAdquisitionItemFrom] = useState<any>({});
    const [adquisitionItemDestiny, setAdquisitionItemDestiny] = useState<any>({});
    const [initBean, setInitBean] = useState<any>({});
    const [missingFields, setMissingFields] = useState<string[]>([]);

    const [modalContra, setModalContra] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalCredit, setModalCredit] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });

    const head = [
        { title: 'Rubro Presupuestal', property: 'BudgetName', visible: true },
        { title: 'Saldo del Rubro Contracrédito', property: 'LeftValue', visible: true, mask: MASK_MONEY },
        { title: 'Valor Contracredito', property: 'ContraCreditValue', visible: true, mask: MASK_MONEY },
        { title: 'Valor Crédito', property: 'CreditValue', visible: true, mask: MASK_MONEY },
        { title: 'PAA', property: 'IDAdquisitionItemFrom', visible: true, mask: MASK_NUMBER },
        { title: 'PAA destino', property: 'IDAdquisitionItemDestinity', visible: true, mask: MASK_NUMBER },
        { title: 'Observación', property: 'Description', visible: true },
    ]

    useEffect(() => {
        if (data.BudgetList.DefaultValue) {
            setLista(data.BudgetList.DefaultValue)
        }
    }, [data.BudgetList])
    // useEffect(() => {
    //     if (setData) {
    //         let key = Object.keys(data);
    //         console.log({ "BudgetList": lista });
            
    //         // setData({ [key[1]]: lista });
    //     }
    // }, [lista])

    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-fill', visible: data.BudgetList.Editable, evento: () => { editar() } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: data.BudgetList.Editable, evento: () => { eliminarItem() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const createItemCC = () => {
        setBean({});
        setInitBean({});
        setAdquisitionItemFrom({});
        setModalContra({ ...modalContra, "view": true, "name": "Crear Linea de Contra Crédito" })
    }

    const createItemCredit = () => {
        setBean({});
        setInitBean({})
        setAdquisitionItemDestiny({});
        setModalCredit({ ...modalCredit, "view": true, "name": "Crear Linea de Crédito" })
    }
    const editar = () => {
        if (bean.ContraCreditValue > 0)
            setModalContra({ ...modalContra, "view": true, "name": "Crear Linea de Contra Crédito" })
        else
            setModalCredit({ ...modalCredit, "view": true, "name": "Crear Linea de Crédito" })
    }

    const eliminarItem = () => {
        const updatedLista = lista.filter((item: any) =>
            JSON.stringify(item.DataBeanProperties) !== JSON.stringify(bean)
        );

        setBean({});
        setLista(updatedLista);
    }

    const iconButtonsItem = [
        { nombre: 'Agregar ContraCredito', visible: data.BudgetList.Editable, icono: 'ri-creative-commons-line', evento: createItemCC },
        { nombre: 'Agregar Crédito', visible: data.BudgetList.Editable, icono: 'ri-copyright-line', evento: createItemCredit },
    ]

    const createNewItemCC = () => {
        const updatedLista = lista.filter((item: any) =>
            JSON.stringify(item.DataBeanProperties) !== JSON.stringify(initBean)
        );

        _budgetSource.instance.createBudgetRowForContraCredit(bean.IDBudgetType, bean.IDBudgetResourceFrom, bean.IDBudgetSourceFrom, bean.BudgetIDFromStr, bean.Value, bean.Description, bean.IDAdquisitionItem).then(
            (resp) => {
                let temp = [...updatedLista, {
                    DataBeanProperties: resp,
                    DataBeanName: 'budget.Budget'
                }];
                setLista(temp);
                setBean({});
                setModalContra({ ...modalContra, "view": false })
            }
        ).catch(
            err => {
                toast.error(err);
            }
        )
    }

    const createNewItemCredit = () => {
        const updatedLista = lista.filter((item: any) =>
            JSON.stringify(item.DataBeanProperties) !== JSON.stringify(initBean)
        );

        _budgetSource.instance.createBudgetRowForCredit(bean.IDBudgetType, bean.IDBudgetResourceDestinity, bean.IDBudgetSourceDestinity, bean.BudgetIDDestinityStr, bean.Value, bean.Description, bean.IDAdquisitionItem).then(
            (resp) => {
                let temp = [...updatedLista, {
                    DataBeanProperties: resp,
                    DataBeanName: 'budget.Budget'
                }];
                setLista(temp);
                setBean({});
                setModalCredit({ ...modalCredit, "view": false })
            }
        ).catch(
            err => {
                toast.error(err);
            }
        )
    }

    const setRowBean = (object: any) => {
        object.IDAdquisitionItem = object.IDAdquisitionItemDestinity ?? object.IDAdquisitionItemFrom;
        setBean(object);
        // setAdquisitionItemDestiny({ IDAdquisitionItem: object.IDAdquisitionItemDestinity })
        // setAdquisitionItemFrom({ IDAdquisitionItem: object.IDAdquisitionItemFrom })
        setInitBean(object)
    }

    const submitForm = () => {

        let key = Object.keys(data);
        console.log({ [key[0]]: lista });

        if (setData) {
            setData({ "BudgetList": lista });
        }
    }

    return (
        <div className="row">
            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={(e) => { setRowBean(e) }} listButtons={listaBotones()} iconButtons={iconButtonsItem} />
            </div>
            <div className="col-md-12">
                <BasicButton icon="ri-send-plane-2-line" clase="primary" eventClick={submitForm}>Guardar</BasicButton>
            </div>

            <div className="col-md-12">
                <Modal modal={modalContra} updateModal={setModalContra} eventModal={createNewItemCC} >
                    <div className="row">
                        <>
                            <div className="col-md-12">
                                <SelectBudgetType idSelector={bean.IDBudgetType} onChange={(e) => { setBean({ ...bean, "IDBudgetType": e }) }} />
                            </div>
                            <div className="col-md-12">
                                <SelectBudgetID label="Rubro Presupuestal Contra Credito" onChange={(e) => { setBean({ ...bean, "BudgetIDFromStr": e.JsonCode }) }} jsonCode={bean.BudgetIDFromStr} edit={false} />
                            </div>
                            {bean.BudgetIDFromStr &&
                                <div className="col-md-12">
                                    <SelectBudgetResourceForYear config={{
                                        date: properties.DocumentDate,
                                        budget: bean.BudgetIDFromStr,
                                    }} idSelector={bean.IDBudgetResourceFrom} onChange={(e) => { setBean({ ...bean, "IDBudgetResourceFrom": e }) }} />
                                </div>
                            }
                            {bean.IDBudgetResourceFrom &&
                                <div className="col-md-12">
                                    <SelectBudgetSourceForYear idSelector={bean.IDBudgetSourceFrom} onChange={(e) => { setBean({ ...bean, "IDBudgetSourceFrom": e }) }} cProps={{
                                        budgetIDSTr: bean.BudgetIDFromStr,
                                        budgetResource: bean.IDBudgetResourceFrom,
                                        date: properties.DocumentDate,
                                    }} />
                                </div>
                            }
                        </>
                        <div className="col-md-12">
                            <label className={`${missingFields.includes('Value') ? 'has-error' : ''}`}>Valor Presupuesto</label>
                            <InputMoney _value={bean.Value} onChange={(e) => { setBean({ ...bean, "Value": e }) }} _label=" " />
                        </div>
                        <div className="col-md-12">
                            <AdquisitionItemSelector idAdquisitionItem={bean.IDAdquisitionItem} onChage={(e) => { setBean({ ...bean, "IDAdquisitionItem": e.IDAdquisitionItem }) }} ConfigProps={{ label: "Necesidad Seleccionada", notSeeProps: true }} />
                        </div>
                        <div className="col-md-12">
                            <label>Descripción</label>
                            <textarea className="form-control" value={bean.Description} onChange={(e) => { setBean({ ...bean, "Description": e.target.value }) }} />
                        </div>
                    </div>
                </Modal>
            </div>
            <div className="col-md-12">
                <Modal modal={modalCredit} updateModal={setModalCredit} eventModal={createNewItemCredit} >
                    <div className="row">
                        <>
                            <div className="col-md-12">
                                <SelectBudgetType idSelector={bean.IDBudgetType} onChange={(e) => { setBean({ ...bean, "IDBudgetType": e }) }} />
                            </div>
                            <div className="col-md-12">
                                <SelectBudgetID label="Rubro Presupuestal Credito" onChange={(e) => { setBean({ ...bean, "BudgetIDDestinityStr": e.JsonCode }) }} jsonCode={bean.BudgetIDDestinityStr} edit={false} />
                            </div>
                            <div className="col-md-12">
                                <BudgetResourceEditor idSelector={bean.IDBudgetResourceDestinity} onChange={(e) => { setBean({ ...bean, "IDBudgetResourceDestinity": e }) }} />
                            </div>

                            <div className="col-md-12">
                                <SelectBudgetSource idSelector={bean.IDBudgetSourceDestinity} onChange={(e) => { setBean({ ...bean, "IDBudgetSourceDestinity": e }) }} />
                            </div>
                            <div className="col-md-12">
                                <label className={`${missingFields.includes('Value') ? 'has-error' : ''}`}>Valor Presupuesto</label>
                                <InputMoney _value={bean.Value} onChange={(e) => { setBean({ ...bean, "Value": e }) }} _label=" " />
                            </div>
                            <div className="col-md-12">
                                <AdquisitionItemSelector idAdquisitionItem={bean.IDAdquisitionItem} onChage={(e) => {   setBean({ ...bean, "IDAdquisitionItem": e.IDAdquisitionItem })}} ConfigProps={{ label: "Necesidad Seleccionada", notSeeProps: true }} />
                            </div>
                            <div className="col-md-12">
                                <label>Descripción</label>
                                <textarea className="form-control" value={bean.Description} onChange={(e) => { setBean({ ...bean, "Description": e.target.value }) }} />
                            </div>
                        </>
                    </div>
                </Modal>
            </div>
        </div>
    )
}